import { HRPortalReportsService } from '@openeducation/oe-rn-services';
import type {
  PurchaserId,
  Organization,
  ReportType,
  ReportFileType,
  ReportParams,
} from '@openeducation/oe-rn-shared-types';
import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

interface HRPortalReportProps {
  purchaserId: PurchaserId;
  accessToken: string;
  organization: Organization;
  reportType: ReportType;
  fileType: ReportFileType;
  params?: ReportParams;
}

export const useHRPortalReport = () => {
  const { environment } = useEnvironmentContext();

  const { isSuccess, isLoading, mutateAsync, reset } = useMutation(
    ({
      accessToken,
      purchaserId,
      organization,
      reportType,
      fileType,
      params,
    }: HRPortalReportProps) =>
      HRPortalReportsService.getReport(
        environment,
        accessToken,
        purchaserId,
        organization,
        reportType,
        fileType,
        params
      )
  );

  useEffect(() => {
    if (isSuccess) {
      reset();
    }
  }, [isSuccess, reset]);

  return {
    getReport: mutateAsync,
    isLoading,
    isSuccess,
  };
};
